import { render } from "./CopyBookingPortalUrl.vue?vue&type=template&id=4c446ace"
import script from "./CopyBookingPortalUrl.vue?vue&type=script&lang=js"
export * from "./CopyBookingPortalUrl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__